import {
  orderReportTypeEnum,
  OrderReportTypeValue,
} from '@/global/enum/orderReport'
import AddReportReceipt from '@/pages/add-report-receipt'
import FilingSheet from '@/pages/filing-sheet'
import { useQuery } from '@/tools/utilHooks'

export default function OrderReportH5() {
  const query = useQuery()
  const type = query.get('type') || ''
  const id = query.get('id') || ''
  return (
    <>
      {orderReportTypeEnum.isValueInLabels(type, ['客户订单报备']) && (
        <AddReportReceipt detail id={id} />
      )}
      {orderReportTypeEnum.isValueInLabels(type, ['商品报备']) && (
        <FilingSheet detail id={id} />
      )}
      {!orderReportTypeEnum.isValueInLabels(type, [
        '商品报备',
        '客户订单报备',
      ]) && <div>暂无该类型报备</div>}
    </>
  )
}
import {
  orderReportTypeEnum,
  OrderReportTypeValue,
} from '@/global/enum/orderReport'
import AddReportReceipt from '@/pages/add-report-receipt'
import FilingSheet from '@/pages/filing-sheet'
import { useQuery } from '@/tools/utilHooks'

export default function OrderReportH5() {
  const query = useQuery()
  const type = query.get('type') || ''
  const id = query.get('id') || ''
  return (
    <>
      {orderReportTypeEnum.isValueInLabels(type, ['客户订单报备']) && (
        <AddReportReceipt detail id={id} />
      )}
      {orderReportTypeEnum.isValueInLabels(type, ['商品报备']) && (
        <FilingSheet detail id={id} />
      )}
      {!orderReportTypeEnum.isValueInLabels(type, [
        '商品报备',
        '客户订单报备',
      ]) && <div>暂无该类型报备</div>}
    </>
  )
}
